interface Props {
  children?: React.ReactNode;
  onClick: () => void;
}

export const PrimaryButton: React.FC<Props> = ({ children, onClick }) => {
  return (
    <>
      <div className="flex items-center px-2">
        <button
          type="button"
          className=" bg-primary-500 text-white rounded-md lg:px-2 md:px-2 px-4 hover:bg-primary-700 py-1.5 lg:text-sm md:text-sm text-xs"
          onClick={onClick}
        >
          <span className="text-500 font-normal">{children}</span>
        </button>
      </div>
    </>
  );
};
